<template>
  <span
    v-if="tag"
    class="session-tag"
    :style="{
      backgroundColor: tags_getColor(tag),
    }"
  >
    <b-img :src="tags_getIcon(tag)" alt="" aria-hidden="true" />
    <span>{{ tags_getName(tag) }}</span>
  </span>
</template>

<script>
import tags from "@/mixins/tags";

export default {
  name: "SessionTag",
  mixins: [tags],
  props: {
    tag: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.session-tag {
  display: flex; /* Horizontal layout */
  align-items: center; /* Vertically center image + text */
  align-self: start;
  width: fit-content;

  border-radius: 5px;
  padding: 4px 8px;

  img {
    width: 16px;
    margin-right: 4px;
  }
  span {
    font-family: Lexend, sans-serif;
    font-size: 14px;
    font-weight: 300;
    line-height: 100%;
    letter-spacing: 0.05rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SessionTag.vue